import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { messages } from '../../resources';
import { getRoute } from './routes';

function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');

  return msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./);
}

function Root({ children }) {
  return <StrictMode>{children}</StrictMode>;
}

export function getActiveWidgets() {
  const widgets = {};

  document.querySelectorAll('script[data-union-widget]').forEach((widget) => {
    const widgetData = {
      'data-union-widget': widget.getAttribute('data-union-widget'),
      'data-union-container': widget.getAttribute('data-union-container'),
      'data-union-props': JSON.parse(widget.innerHTML)
    };
    const container = document.getElementById(widgetData['data-union-container']);

    if (!container) {
      return null;
    }

    const route = getRoute(widgetData['data-union-widget']);

    if (route) {
      widgets[widgetData['data-union-widget']] = {
        rootId: route.id,
        props: widgetData['data-union-props'],
        root: route.component
      };
    } else {
      console.error(`Route not found for ${widgetData['data-union-widget']}`);
    }
  });

  return widgets;
}

export function mountUnion() {
  const widgets = getActiveWidgets();
  Object.values(widgets).forEach((widget) => {
    justRender(<Union widget={widget} />, widget.rootId);
  });
}

export function unmountUnion() {
  const widgets = getActiveWidgets();
  Object.values(widgets).forEach((widget) => {
    justUnmountComponentAtNode(widget.rootId);
  });
}
export function justRender(reactElement, rootId) {
  const container = document.getElementById(rootId);
  const root = createRoot(container);

  if (isIE()) {
    return root.render(
      <div className="alert alert-danger" role="alert">
        <div className="alert-content">
          <p>
            <span>{messages.ieException}</span>
          </p>
        </div>
      </div>
    );
  }

  root.render(<Root>{reactElement}</Root>);
}

export function justUnmountComponentAtNode(rootId) {
  const container = document.getElementById(rootId);
  const root = createRoot(container);

  root.unmount();
}

export const Union = ({ widget }) => {
  const Component = widget.root;

  return (
    <Suspense fallback={messages.loading}>
      <Component data={widget.props} namespace={widget.rootId} />
    </Suspense>
  );
};
